import React, { useState, useMemo, useEffect } from "react";
import trackStore from "@/stores/clipEditor/trackState";
import playerStore from "@/stores/clipEditor/player";
import { getId } from "@/utils/tool";
import { Slider } from "@arco-design/web-react";
import { observer } from "mobx-react";
// import {
//   UndoIcon,
//   RedoIcon,
//   SplitIcon,
//   DeleteIcon,
//   SubIcon,
//   AddIcon,
// } from "@/icons"; // 假设图标组件已导入

interface ToolbarProps {
  value?: number; // 默认值为 30
  onChange?: (val: number) => void; // 更新 value 的回调
}

const Toolbar: React.FC<ToolbarProps> = ({ value = 30, onChange }) => {
  // 图标配置
  const icons = useMemo(
    () => [
      {
        title: "撤销",
        disable: true,
        // icon: UndoIcon,
      },
      {
        title: "前进",
        disable: true,
        // icon: RedoIcon,
      },
      {
        title: "分割",
        disable:
          trackStore.selectTrackItem.line === -1 &&
          trackStore.selectTrackItem.index === -1,
        // icon: SplitIcon,
      },
      {
        title: "删除",
        disable:
          trackStore.selectTrackItem.line === -1 &&
          trackStore.selectTrackItem.index === -1,
        // icon: DeleteIcon,
      },
    ],
    [trackStore.selectTrackItem]
  );

  // Slider 配置
  const sliderProps = {
    size: "small",
    step: 10,
    max: 70,
    min: 0,
  };

  // SVG 样式
  const svgStyle = {
    fontSize: "1.75rem",
    padding: "0.25rem",
    boxSizing: "content-box",
  };

  // 修改缩放比例
  const changeScale = (val: number) => {
    let newVal = value + val;
    if (newVal > sliderProps.max) newVal = sliderProps.max;
    if (newVal < sliderProps.min) newVal = sliderProps.min;
    if (onChange) {
      onChange(newVal);
    }
  };

  // 处理图标点击事件
  const handleIconClick = (item: { icon?: string; disable?: boolean }) => {
    const { icon: type, disable } = item;
    if (disable) return;

    if (type === "DeleteIcon") {
      if (
        trackStore.selectTrackItem.line !== -1 &&
        trackStore.selectTrackItem.index !== -1
      ) {
        trackStore.removeTrack(
          trackStore.selectTrackItem.line,
          trackStore.selectTrackItem.index
        );
        trackStore.selectTrackItem.line = -1;
        trackStore.selectTrackItem.index = -1;
      }
    } else if (type === "UndoIcon") {
      // store._undo();
    } else if (type === "RedoIcon") {
      // store._redo();
    } else if (type === "SplitIcon") {
      // 判断分割时间是否在视频内
      const splitTime = playerStore.playStartFrame;
      const active =
        trackStore.trackList[trackStore.selectTrackItem.line].list[
          trackStore.selectTrackItem.index
        ];

      if (
        splitTime > active.start &&
        splitTime < active.end &&
        active.type === "video"
      ) {
        const videoTrack = (active as any).split(splitTime);
        videoTrack.resize({
          width: playerStore.playerConfig.playerWidth,
          height: playerStore.playerConfig.playerHeight,
        });
        trackStore.addTrack(videoTrack);
      }
    }
  };

  return (
    <div className="pl-4 pb-1 pr-10 w-full h-10 border-b dark:border-darker border-gray-300">
      {/* 左侧图标区域 */}
      <div className="float-left h-9 w-32 flex flex-row flex-nowrap items-center justify-around">
        {icons.map((item) => (
          <div key={item.title} onClick={() => handleIconClick(item)}>
            {/* <item.icon
              className={`focus:outline-0 ${item.disable ? "cursor-not-allowed text-gray-400" : ""}`}
            /> */}
          </div>
        ))}
      </div>

      {/* 右侧缩放控制区域 */}
      <div
        className="float-right flex w-52 h-9 justify-center items-center"
        style={{ float: "right", transform: "translate(0, -20px)" }}
      >
        {/* <SubIcon
          style={svgStyle}
          className="cursor-pointer mr-4"
          onClick={() => changeScale(-10)}
        /> */}
        <div style={{ display: "flex", alignItems: "center" }}>
          <div style={{ color: "#666", fontSize: 14, marginRight: 12 }}>
            轨道缩放
          </div>
          <Slider
            style={{ width: 100 }}
            tooltipVisible={false}
            value={value}
            onChange={(val: number) => {
              onChange?.(val);
            }}
            {...sliderProps}
          />
        </div>

        {/* <AddIcon
          style={svgStyle}
          className="cursor-pointer ml-4"
          onClick={() => changeScale(10)}
        /> */}
      </div>
    </div>
  );
};

export default observer(Toolbar);
